import React, { Fragment, useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import NoPermission from "../../common/NoPermission";
import { useDispatch, useSelector } from "react-redux";
import LoaderSpinner from "../../common/LoaderSpinner";
import FileUpload from "../../common/FileUpload";
import {
  getStudentProfileForUpdateOnly,
  getStudentProfileByFormNumber,
  getPayableFeeForStudent,
  savePaymentRecords,
  resetStudentProfile,
  getAllRegistrations,
  updateStudentRestriction
} from "../../api/admissionApi";
import { uploadSingleFileToS3 } from "../../api/fileUploadApi";
import RegistrationInfo from "./RegistrationInfo";
import moment from "moment";

export default function CollegeFeesSystem() {

const renderHeader = () => {
    return (
        <Fragment>
        <div className="section-body">
            <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
                <div className="header-action">
                <h1 className="page-title">College Fees System</h1>
                <ol className="breadcrumb page-breadcrumb">
                    <li className="breadcrumb-item">
                    <span>St. Andrews College</span>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                    Create/update college fees system
                    </li>
                </ol>
                </div>
            </div>
            </div>
        </div>
        </Fragment>
    );
};
const renderContent = () => {
    return (
        <div className="card">
        <div className="card-header">
            <h3 className="card-title">Create or update college fees system</h3>
        </div>

        <div className="card-body" style={{marginTop: 0, paddingTop: 0}}>
        <p>TODO on this panel:</p>
        <LoaderSpinner />
        </div>
        </div>
    );
};

  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  )
}
